/* eslint-disable import/prefer-default-export,camelcase */
import Vue from 'vue'
import url from '@/services/ApiServices/apiUrls'
import { store } from '@/store/store'

// choose a vendor inventory and promotional price array for make calculations easy
export function assignVendorInventoryAndPromotionalPrices (
	product,
	vpiIndex = 0
) {
	let vpi = product.vendor_product_inventories
	let maximumprice = 5000
	// if (product.product_specification) {
	//   product.product_specification = Object.entries(product.product_specification);
	// }
	if (vpi && vpi.length > 0) {
		vpi = vpi[vpiIndex]
		if (vpi && maximumprice < vpi.price) {
			maximumprice = vpi.price
		}
		product.vpi = vpi
		product.stock = vpi.available_stock
		product.max_quantity = vpi.max_quantity
		product.price = vpi.price
		product.vendor_id = vpi.vendor_id
		product.vendor_name = vpi.vendor_name
	}
	if (vpi && vpi.promotional_prices) {
		let promo = vpi.promotional_prices
		product.promotions = promo
		if (vpi && vpi.length > 0 && promo && promo.length > 0) {
			promo = promo[0]
		}
		product.maximumprice = maximumprice
		if (promo && promo[0]) {
			product.promotion = promo[0]
			product.promotion_id = promo[0].promotion_id
			product.promotion_applied_price = promo[0].promotion_applied_price
			product.discount_percentage = promo[0].promotion_percentage
		}
	}
	if (
		product.product_details &&
		product.product_details.images &&
		product.product_details.images[0]
	) {
		product.image_url = product.product_details.images[0]
	}
}
export function filterFunction (element) {
	return element.vendor_product_inventories.length > 0
}
export function setSortMethod (sortOrder, sortMethod) {
	const sort = {
		sortOrder,
		sortMethod
	}
	store.dispatch('filters/setSortData', sort)
}
export function removeVendorProducts (products) {
	return products.filter(filterFunction)
}
/* function to set and update filter keys based on product response */
export function createAndAssignFiltersInVuexStorage (res) {
	if (store.getters['filters/getFilterAppliedStatus'] === false) {
		let filterData = res.data.filter_class.filters
		const ratings = {
			filterName: 'ratings',
			filterValues: res.data.filter_class.ratings
		}
		const vendors = {
			filterName: 'vendors',
			filterValues: res.data.filter_class.vendors
		}
		const discount_amount = {
			filterName: 'discount above(amount)',
			filterValues: [1000, 5000, 10000, 50000]
		}
		const discount_percentage = {
			filterName: 'discount above(%)',
			filterValues: [10, 25, 50, 75]
		}
		const maxPrice = res.data.filter_class.max_price
		const minPrice = res.data.filter_class.min_price
		let price = (maxPrice - minPrice) / 10
		const mobilePriceFilterValues = []
		for (let i = 1; i <= 10; i++) {
			let priceData = parseInt((price * i).toFixed(), 10)
			mobilePriceFilterValues.push(priceData)
		}
		const mobilePriceFilter = {
			filterName: 'price(upto)',
			filterValues: mobilePriceFilterValues
		}
		filterData.push(ratings)
		filterData.push(vendors)
		filterData.push(discount_amount)
		filterData.push(discount_percentage)
		filterData.push(mobilePriceFilter)
		store.dispatch('filters/setFilterClassResponse', res.data.filter_class)
		store.dispatch('filters/setFilter', res.data.filter_class.filters)
		store.dispatch('filters/updateFilters', res.data.filter_class.filters)
		if (
			res.data &&
			res.data.segmented_product &&
			res.data.segmented_product.product_data &&
			res.data.segmented_product.product_data[0] &&
			res.data.segmented_product.product_data[0].parents
		) {
			store.dispatch(
				'category/setActiveCategories',
				JSON.parse(
					JSON.stringify(
						res.data.segmented_product.product_data[0].parents.slice().reverse()
					)
				)
			)
		} else {
			store.dispatch('category/setActiveCategories', [])
		}
	}
	// let maximumprice = 5000
	res.data.segmented_product.product_data.forEach(element => {
		assignVendorInventoryAndPromotionalPrices(element)
	})
	// maximumprice = Math.ceil(maximumprice / 1000) * 1000
	// store.dispatch('filters/updatePriceRange', [0, maximumprice]);
	const allProductsData = removeVendorProducts(
		res.data.segmented_product.product_data
	)
	store.dispatch(
		'productselected/setSelectedProductData',
		removeVendorProducts(allProductsData)
	)
}

export const productApi = new Vue({
	methods: {
		getAllProductsByVendor (vendorId) {
			const getUrl = url.getAllVendorProductsUrl + vendorId
			return new Promise((resolve, reject) => {
				this.$http
					.get(getUrl)
					.then(res => {
						// store.dispatch('category/setCategoryData', res.data);
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getCategories () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getCategories)
					.then(res => {
						store.dispatch('category/setCategoryData', res.data)
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getPromotions () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getPromotions)
					.then(res => {
						store.dispatch('promotions/setAllPromotions', res.data)
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getPromotionalProducts (promotionId) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getPromotionalProducts + promotionId)
					.then(res => {
						store.dispatch('filters/setFilter', [])
						store.dispatch('filters/updateFilters', [])
						const products = JSON.parse(JSON.stringify(res.data))
						const categories = []
						products.forEach(product1 => {
							assignVendorInventoryAndPromotionalPrices(product1)
							store.getters['category/getCategoryData'].forEach(category => {
								category.sub_categories.forEach(subCategory => {
									subCategory.sub_categories.forEach(classification => {
										if (classification.category_id === product1.category_id) {
											if (
												categories.filter(
													categoriy => categoriy.category_id === classification.category_id
												).length === 0
											) {
												categories.push(classification)
											}
										}
									})
								})
							})
						})
						if (categories.length === 1) {
							let maximumprice = 5000
							products.forEach(element => {
								let vpi = element.vendor_product_inventories
								if (vpi && vpi.length > 0) {
									vpi = vpi[0]
									if (vpi && maximumprice < vpi.price) {
										maximumprice = vpi.price
									}
								}
							})
							maximumprice = Math.ceil(maximumprice / 1000) * 1000
							// store.dispatch('filters/updatePriceRange', [0, maximumprice]);
						}
						store.dispatch('category/setActiveCategories', categories)
						if (categories.length > 0) {
							this.updateKeyWord(
								JSON.parse(
									JSON.stringify({
										name: categories[0].category_name,
										category: categories[0].category_id,
										is_a_category: true
									})
								)
							)
						}
						store.dispatch('productselected/setSelectedProductData', products)
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getProductsByIds (ids, from, categoryId) {
			return new Promise((resolve, reject) => {
				const postUrl = categoryId ? url.getProductsByIdsWithCategoryIdUrl + categoryId : url.getProductsByIdsUrl
				this.$http
					.post(postUrl, ids)
					.then(res => {
						if (res && res.data && res.data[0]) {
							store.dispatch(
								'category/setActiveCategories',
								JSON.parse(JSON.stringify(res.data[0].parents.slice().reverse()))
							)
						}
						const products = JSON.parse(JSON.stringify(res.data))
						products.forEach(product => {
							assignVendorInventoryAndPromotionalPrices(product)
						})
						if (!(from && (from === 'wish-list' || from === 'recentProducts'))) {
							store.dispatch('productselected/setSelectedProductData', products)
						} else {
							store.dispatch('recentview/setRecentSelectedProductsData', products)
						}
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getRecommended (count) {
			const a = []
			return new Promise((resolve, reject) => {
				const postUrl = `${url.getRecommendedProductsUrl}${count}`
				this.$http
					.post(postUrl)
					.then(res => {
						res.data.forEach((e) => {
							a.push(e)
						})
						resolve(res)
						return a
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getByIds (recommendProductIds) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.getByIdsUrl}`
				this.$http
					.post(getUrl, recommendProductIds)
					.then(res => {
						store.dispatch('filters/setFilter', [])
						store.dispatch('filters/updateFilters', [])
						if (res && res.data && res.data[0]) {
							store.dispatch(
								'category/setActiveCategories',
								JSON.parse(JSON.stringify(res.data[0].parents.slice().reverse()))
							)
						}
						const products = JSON.parse(JSON.stringify(res.data))
						store.dispatch('home/setRecommendedProductsData', products)
						products.forEach(product => {
							assignVendorInventoryAndPromotionalPrices(product)
						})
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		async getRecommendedProducts (count) {
			let a = await this.getRecommended(count)
			await this.getByIds(a.data)
		},
		getSearchNames (searchWord) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.getSearchKeys}${searchWord}`
				this.$http
					.get(getUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
						if (e.status === 400) {
							Vue.toasted.show('No Results Found..')
						}
					})
			})
		},
		getSearchKeys (searchWord) {
			return new Promise((resolve, reject) => {
				const getUrl = `${url.getSearchKeys}${searchWord}`
				this.$http
					.get(getUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getFashion () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getFashion)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getMostSaled () {
			return new Promise((resolve, reject) => {
				this.$http
					.get(url.getMostSaled)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		verifyPromoCode (promoCode) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.verifyPromoCodeUrl}${promoCode}`
				this.$http
					.post(postUrl)
					.then(res => {
						if (
							res.status === 200 &&
							res.data &&
							res.data.quantity &&
							res.data.quantity > 0
						) {
							store.dispatch('user/setPromoCodeData', res.data)
							// store.dispatch('buynow/updateGiftCardQuantity');
							// store.dispatch('cart/updateGiftCardCartQuantity');
						} else {
							store.dispatch('user/setPromoCodeData', '')
						}
						resolve(res)
					})
					.catch(e => {
						// store.dispatch('user/setPromoCodeData', '');
						reject(e)
					})
			})
		},
		getSearchedFilteredProducts (
			filterAndQueryData,
			urlReference = '',
			sortOrder = store.getters['filters/getSortData'].sortOrder,
			sortMethod = store.getters['filters/getSortData'].sortMethod,
			startIndex = 0,
			length = 1500
		) {
			// const defaultVendor = store.getters['user/getUserData'].default_vendor;
			return new Promise((resolve, reject) => {
				let apiData = filterAndQueryData
				let postUrl = `${
					url.getSearchProductsUrl
				}?sortOrder=${sortOrder}&sortMethod=${sortMethod}&index=${startIndex}&count=${length}`
				if (urlReference === 'filteredAllProducts') {
					postUrl = `${
						url.getFilteredAllProductsUrl
					}?sortOrder=${sortOrder}&sortMethod=${sortMethod}&index=${startIndex}&count=${length}`
					apiData = filterAndQueryData.filter_class
				} else if (urlReference === 'searchProducts') {
					postUrl = `${
						url.getSearchProductsUrl
					}?sortOrder=${sortOrder}&sortMethod=${sortMethod}&index=${startIndex}&count=${length}`
					apiData = filterAndQueryData.query_parameter
				} else if (urlReference === 'filteredSearchProducts') {
					postUrl = `${
						url.getFilteredSearchProductsUrl
					}?sortOrder=${sortOrder}&sortMethod=${sortMethod}&index=${startIndex}&count=${length}`
					apiData = filterAndQueryData
				}
				this.$http
					.post(postUrl, apiData)
					.then(res => {
						setSortMethod(sortOrder, sortMethod)
						createAndAssignFiltersInVuexStorage(res)
						if (filterAndQueryData.query_parameter) {
							store.dispatch(
								'filters/updateKeyWord',
								JSON.parse(JSON.stringify(filterAndQueryData.query_parameter))
							)
						} else {
							store.dispatch('filters/updateKeyWord', '')
						}
						this.$forceUpdate()
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getVendor (locationDetails, distance) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.getVendorUrl}?lat=${locationDetails.lat}&lng=${
					locationDetails.lng
				}&search_distance=${distance}`
				this.$http
					.get(postUrl)
					.then(res => {
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		getSimilarVariantProducts (groupId) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.getSimilarVariantProductsUrl}${groupId}`
				this.$http
					.get(postUrl)
					.then(res => {
						const products = JSON.parse(JSON.stringify(res.data))
						products.forEach(product => {
							assignVendorInventoryAndPromotionalPrices(product)
						})
						store.dispatch(
							'productselected/setSelectedWpVariantProductsData',
							products
						)
						resolve(res)
					})
					.catch(e => {
						reject(e)
					})
			})
		}
	}
})
